/* eslint-disable react/require-default-props */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Flex, Label, Pane, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Validator } from '@leverege/validator';
import useForgotPassword from './hooks/useForgotPassword.js';
import { ForgotPasswordDefaultProps } from './Constants.js';
import S from './Login.css';
import useForm from './hooks/useForm.js';
import FieldErrorsComponent from "./views/FieldErrorsComponent.js";
const {
  t,
  tf
} = I18N.ns('login.ForgotPassword');
export default function ForgotPassword(props) {
  const userRef = useRef();
  const {
    classNames: {
      className,
      backClassName,
      labelClassname,
      usernameVariant,
      userClassName,
      warningClassName,
      submitClassName
    },
    components: {
      LogoComponent,
      ErrorComponent,
      ForgotPasswordInstructionComponent
    },
    variants: {
      variant,
      backToLoginVariant,
      labelVariant,
      loginLogoVariant,
      warningVariant
    },
    options: {
      getShouldDisplayLogo,
      warningLocation
    },
    state: {
      error,
      onSubmit: pOnSubmit,
      submitted
    },
    onBackToLogin
  } = useForgotPassword(props);
  const {
    errors,
    values,
    onChange,
    onSubmit
  } = useForm({
    fields: {
      email: {
        validator: Validator.required,
        errorMessage: tf('emailError')
      }
    },
    onSubmit: pOnSubmit
  });
  useEffect(() => {
    const userInterval = setInterval(() => {
      if (userRef.current?.value) {
        onChange({
          data: 'email',
          value: userRef.current.value
        });
        clearInterval(userInterval);
      }
    }, 100);
    return () => {
      clearInterval(userInterval);
    };
  }, []);
  const displayLogo = getShouldDisplayLogo(props, 'login/login');
  return /*#__PURE__*/React.createElement(Pane, {
    className: className,
    variant: variant,
    layout: "flex:colS"
  }, /*#__PURE__*/React.createElement(Flex, {
    inline: true,
    variant: "colM",
    align: "center"
  }, displayLogo && LogoComponent ? /*#__PURE__*/React.createElement(LogoComponent, {
    variant: loginLogoVariant
  }) : null, /*#__PURE__*/React.createElement(Pane, {
    variant: "loginPaneHalf",
    layout: "flex:colMCenter"
  }, warningLocation === 'top' && ErrorComponent ? /*#__PURE__*/React.createElement(ErrorComponent, {
    variant: warningVariant,
    className: warningClassName,
    error: error
  }) : null, /*#__PURE__*/React.createElement(ForgotPasswordInstructionComponent, {
    submitted: submitted
  }), /*#__PURE__*/React.createElement("form", {
    className: S.form,
    onSubmit: e => {
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colM",
    align: "stretch"
  }, !submitted && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    variant: labelVariant,
    className: labelClassname
  }, t('emailText')), /*#__PURE__*/React.createElement(TextInput, {
    error: !!errors.email,
    domRef: userRef,
    variant: usernameVariant,
    className: userClassName,
    alwaysFireOnReturn: true,
    value: values.email,
    hint: t('emailHint'),
    eventData: "email",
    onChange: onChange,
    autoComplete: "username"
  }), /*#__PURE__*/React.createElement(FieldErrorsComponent, {
    errors: errors.email
  }), /*#__PURE__*/React.createElement(Button, {
    className: submitClassName,
    type: "button",
    onClick: onSubmit
  }, t('resetText'))), /*#__PURE__*/React.createElement(Button, {
    variant: backToLoginVariant,
    className: backClassName,
    type: "button",
    onClick: onBackToLogin
  }, t('backText')))))));
}
ForgotPassword.propTypes = {
  classNames: PropTypes.exact({
    className: PropTypes.string,
    backClassName: PropTypes.string,
    labelClassname: PropTypes.string,
    usernameVariant: PropTypes.string,
    userClassName: PropTypes.string,
    warningClassName: PropTypes.string,
    submitClassName: PropTypes.string
  }),
  components: PropTypes.exact({
    ErrorComponent: PropTypes.elementType,
    ForgotPasswordInstructionComponent: PropTypes.elementType,
    LoadingComponent: PropTypes.elementType,
    LogoComponent: PropTypes.elementType
  }),
  variants: PropTypes.exact({
    variant: PropTypes.string,
    backToLoginVariant: PropTypes.string,
    labelVariant: PropTypes.string,
    loginLogoVariant: PropTypes.string,
    usernameVariant: PropTypes.string,
    warningVariant: PropTypes.string
  }),
  options: PropTypes.exact({
    getShouldDisplayLogo: PropTypes.func,
    warningLocation: PropTypes.oneOf(['top', 'bottom'])
  }),
  state: PropTypes.exact({
    error: PropTypes.shape({
      message: PropTypes.string,
      status: PropTypes.number,
      errorCode: PropTypes.string
    }),
    email: PropTypes.string,
    onChangeEmail: PropTypes.func,
    onSubmit: PropTypes.func,
    submitDisabled: PropTypes.func
  })
};